export const buildSignupDecorationOrUndefined = (data) => {
    var _a, _b, _c, _d, _e;
    if (!data)
        return undefined;
    return {
        page: (_a = data.page) !== null && _a !== void 0 ? _a : '',
        stage: (_b = data.stage) !== null && _b !== void 0 ? _b : 'never-logged-in',
        planId: (_c = data.planId) !== null && _c !== void 0 ? _c : 'FREE_2016',
        dateAdded: (_d = data.dateAdded) !== null && _d !== void 0 ? _d : 0,
        numAttempts: (_e = data.numAttempts) !== null && _e !== void 0 ? _e : 0,
    };
};
export const signupDecorationNewSignup = ({ planId, pathname, numAttempts, }) => {
    const attempts = numAttempts ? numAttempts + 1 : 1;
    return {
        planId,
        stage: 'never-logged-in',
        page: pathname,
        dateAdded: Date.now(),
        numAttempts: attempts,
    };
};
